import React from "react";
import { Box, Typography, Grid, IconButton, CardContent } from "@mui/material";
import { Bloodtype } from "@mui/icons-material"; // Blood drop icon

export const BloodBank = () => {
  // Static data for blood intake and components
  const bloodData = [
  {
    blood_group: { name: "A+" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 30 },
          { name: "Platelets", stock: 20 },
          { name: "RBC", stock: 40 },
        ],
      },
    ],
  },
  {
    blood_group: { name: "B+" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 25 },
          { name: "Platelets", stock: 18 },
          { name: "RBC", stock: 35 },
        ],
      },
    ],
  },
  {
    blood_group: { name: "O+" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 50 },
          { name: "Platelets", stock: 15 },
          { name: "RBC", stock: 60 },
        ],
      },
    ],
  },
  // New blood groups added here
  {
    blood_group: { name: "AB+" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 40 },
          { name: "Platelets", stock: 22 },
          { name: "RBC", stock: 45 },
        ],
      },
    ],
  },
  {
    blood_group: { name: "A-" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 28 },
          { name: "Platelets", stock: 16 },
          { name: "RBC", stock: 38 },
        ],
      },
    ],
  },
  {
    blood_group: { name: "B-" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 22 },
          { name: "Platelets", stock: 14 },
          { name: "RBC", stock: 33 },
        ],
      },
    ],
  },
  {
    blood_group: { name: "O-" },
    blood_items: [
      {
        component: [
          { name: "Plasma", stock: 45 },
          { name: "Platelets", stock: 12 },
          { name: "RBC", stock: 55 },
        ],
      },
    ],
  },
];

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={3} justifyContent="center">
        {/* Loop through all blood groups */}
        {bloodData.map((bloodIntake, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            {/* Blood drop shaped card */}
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: 200,
                height: 250,
                backgroundColor: "#e60000", 
                clipPath:"path('M 100 220 C 150 220, 200 180, 200 140 C 200 100, 150 40, 100 20 C 50 40, 0 100, 0 140 C 0 180, 50 220, 100 220 Z')",
                boxShadow: 3,
                padding: 2,
                color: "white",
                textAlign: "center",
              }}
            >
              {/* Blood Drop Icon */}
              <IconButton sx={{ fontSize: 50, color: "white" }}>
                <Bloodtype />
              </IconButton>

              {/* Blood Group Name */}
              <Typography variant="h6" sx={{ mt: 1, fontWeight: "bold" }}>
                {bloodIntake.blood_group.name}
              </Typography>

              {/* List of Components with Available Stock */}
              <CardContent sx={{ p: 0 }}>
                {bloodIntake.blood_items[0].component.map((component, idx) => (
                  <Box key={idx} sx={{ mt: 1 }}>
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                      {component.name}
                    </Typography>
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                      Stock: {component.stock} Units
                    </Typography>
                  </Box>
                ))}
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
